import { createPortal } from "react-dom";

export default function BulkActionsBar({ count, actions }) {
  if (!count) return null;

  return createPortal(
    <div
      role="toolbar"
      aria-label="Bulk actions for selected rows"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 2200,
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        gap: 4,
        padding: "10px 14px",
        background: "#15274a",
        borderRadius: 12,
        boxShadow: "0 10px 40px rgba(0,0,0,0.28)",
        maxWidth: "96vw",
        overflowX: "auto",
        border: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <span
        style={{
          background: "#3b82f6",
          color: "#fff",
          padding: "5px 12px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 700,
          marginRight: 6,
          flexShrink: 0,
        }}
      >
        {count} item{count === 1 ? "" : "s"}
      </span>

      {actions.filter(Boolean).map((action) => (
        <button
          key={action.key}
          type="button"
          onClick={action.onClick}
          disabled={action.disabled}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "6px 10px",
            border: "none",
            borderRadius: 8,
            background: action.danger ? "rgba(239,68,68,0.2)" : "transparent",
            color: "#fff",
            fontSize: 12,
            fontWeight: 500,
            cursor: action.disabled ? "not-allowed" : "pointer",
            fontFamily: "inherit",
            whiteSpace: "nowrap",
            flexShrink: 0,
            opacity: action.disabled ? 0.55 : 1,
          }}
          onMouseEnter={(e) => {
            if (!action.danger && !action.disabled) e.currentTarget.style.background = "rgba(255,255,255,0.12)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = action.danger ? "rgba(239,68,68,0.2)" : "transparent";
          }}
        >
          {action.icon}
          {action.label}
        </button>
      ))}
    </div>,
    document.body
  );
}

export const bulkIcons = {
  edit: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  set: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  selectAll: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9 11 12 14 22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  ),
  clear: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="2" />
    </svg>
  ),
  delete: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FCA5A5" strokeWidth="2">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  ),
};
